import React from "react";

import Error, { ErrorContainer } from "ui/Error";
import FileErrorIcon from "assets/svg/file-error.svg";

const NotFoundPage = () => {
  return (
    <ErrorContainer>
      <Error title="Page not found" Icon={FileErrorIcon} />
    </ErrorContainer>
  );
};

export default NotFoundPage;
